module.exports = __webpack_public_path__ + "img/nav_1.d4423560.png";